import React from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow,
    Lookup
} from 'devextreme-react/data-grid';
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarServicosLCPDs } from "../DataSources";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";

export default class ServicosLCPBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
        this.state = {
            checkBoxValue: 'servicoAtivo'
        };
        this.tiposTributacao = [
            { id: "T", descricao: "Tomador" },
            { id: "P", descricao: "Prestador" },
        ];
        this.tipoPessoa = [
            { id: "PJ", descricao: "Pessoa Jurídica" },
            { id: "PF", descricao: "Pessoa Física" },
        ];
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Lista de Serviços LCP">
                    <DataGrid
                        dataSource={criarServicosLCPDs()}
                        showBorders={true}
                        rowAlternationEnabled={true} remoteOperations={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={'categoriaLcp116Codigo'} caption={"Categoria"} width={'120'}/>
                        <Column dataField={'id'} caption={"Código LCP"} width={'120'}/>
                        <Column dataField={'descricao'} caption={"Descrição"} width={'300'} />
                        <Column dataField={'localTributacao'} caption={"Tipo de Tributação"}>
                            <Lookup
                                dataSource={this.tiposTributacao}
                                valueExpr={"id"}
                                displayExpr={"descricao"} />
                        </Column>
                        <Column dataField={'tipoPessoa'} caption={"Tipo de Pessoa"}>
                            <Lookup
                                dataSource={this.tipoPessoa}
                                valueExpr={"id"}
                                displayExpr={"descricao"} />
                        </Column>
                        <Column dataField={'servicoAtivo'} caption={"Ativo"} editorType={"dxCheckBox"} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }

}
